import type { ReactNode } from 'react'

export interface FullTourProps {
  onComplete: () => void
  onSkip: () => void
}

export type TourPageKey =
  | 'intro'
  | 'step-one'
  | 'step-two'
  | 'step-three'
  | 'step-four'
  | 'step-five'
  | 'step-six'
  | 'step-seven'
  | 'step-eight'

type TourPageLayout = 'intro' | 'step'

export type TourPageShell =
  | 'intro'
  | 'step'
  | 'projects'
  | 'timesheets'
  | 'monthly-signoff'
  | 'user-management'
  | 'funding-potential'

export interface TourPageNavigation {
  onBack: () => void
  onBegin: () => void
  onNext: () => void
  onSkip: () => void
}

export type TourPageRenderer = (navigation: TourPageNavigation) => ReactNode

export interface TourPageDefinition {
  key: TourPageKey
  layout: TourPageLayout
  nextKey?: TourPageKey
  previousKey?: TourPageKey
  progressIndex: number | null
  renderer: TourPageRenderer
  shell: TourPageShell
}
